import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { OopsGemDatePickerComponent } from './oops-gem-datepicker.component';
import { DebounceKeyUpModule } from 'src/app/shared/utils/directives/debounces/debounce-keyup.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    DebounceKeyUpModule
  ],
  declarations: [
    OopsGemDatePickerComponent,
  ],
  exports: [OopsGemDatePickerComponent]
})
export class OopsGemDatePickerModule { }
